<template>
    <div class="leasingSearchListing__inner">
        <div
            class="leasingSearchFilter"
            :class="{
    'leasingSearchFilter--open': filterActive && windowWidth <= 800,
}"
        >
            <div class="leasingSearchFilter__wrap">
                <div class="leasingSearchFilter__header">
                    <button
                        type="button"
                        class="leasingSearchFilter__closeButton"
                        @click="toggleFilter"
                        v-if="windowWidth <= filterFlyoutBreakpoint"
                    >
                        <svg viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="FPA" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
                                <g id="FPA-pop-up" transform="translate(-1359.000000, -199.000000)" fill="currentColor">
                                    <path d="M1374.07027,212.000036 L1384.77337,222.703135 C1384.92962,222.911468 1385.00775,223.145843 1385.00775,223.406259 C1385.00775,223.666674 1384.92962,223.875007 1384.77337,224.031257 L1384.07025,224.73438 C1383.914,224.89063 1383.70567,224.968755 1383.44525,224.968755 C1383.18483,224.968755 1382.95046,224.89063 1382.74213,224.73438 L1372.03903,213.953156 L1361.33593,224.73438 C1361.12759,224.89063 1360.89322,224.968755 1360.6328,224.968755 C1360.37239,224.968755 1360.16406,224.89063 1360.00781,224.73438 L1359.30468,224.031257 C1359.14843,223.875007 1359.07031,223.666674 1359.07031,223.406259 C1359.07031,223.145843 1359.14843,222.911468 1359.30468,222.703135 L1370.08591,212.000036 L1359.30468,201.296936 C1359.14843,201.088603 1359.07031,200.854229 1359.07031,200.593813 C1359.07031,200.333397 1359.14843,200.125064 1359.30468,199.968814 L1360.00781,199.265691 C1360.16406,199.109441 1360.37239,199.031317 1360.6328,199.031317 C1360.89322,199.031317 1361.12759,199.109441 1361.33593,199.265691 L1372.03903,209.968791 L1382.74213,199.265691 C1382.95046,199.109441 1383.18483,199.031317 1383.44525,199.031317 C1383.70567,199.031317 1383.914,199.109441 1384.07025,199.265691 L1384.77337,199.968814 C1384.92962,200.125064 1385.00775,200.333397 1385.00775,200.593813 C1385.00775,200.854229 1384.92962,201.088603 1384.77337,201.296936 L1374.07027,212.000036 Z" id="close"></path>
                                </g>
                            </g>
                        </svg>
                    </button>

                    <h2 class="leasingSearchFilter__title">
                        Filter
                    </h2>

                    <div class="leasingSearchFilter__clear">
                        <a
                            href="/leasing/"
                            v-if="params.length > 0"
                        >
                            Clear
                        </a>
                    </div>
                </div>

                <div class="leasingSearchFilter__options">
                     <LeasingSearchFilterOption
                        :open="accordions.makeAndModel.open"
                        context="makeAndModel"
                        title="Make & model"
                        @toggle-option="handleToggleOption"
                    >
                        <LeasingSearchFilterSelect
                            default-value="Any"
                            :items="filters.makes.options"
                            id="make"
                            label="Make"
                            name="make"
                            :selected-value="make"
                            @filter-update="handleMakeChange"
                        />

                        <LeasingSearchFilterSelect
                            default-value="Any"
                            :disabled="!make"
                            :items="filters.models.options"
                            id="model"
                            label="Model"
                            name="model"
                            :selected-value="model"
                            @filter-update="handleModelChange"
                        />
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.type.open"
                        context="type"
                        title="Type"
                        @toggle-option="handleToggleOption"
                    >
                        <LeasingSearchFilterCheckbox v-for="(item, index) in filters.vehicleType.vehicleType"
                                               :id="`vehicleType-${index}`"
                                               :label="item.name"
                                               name="vehicleType[]"
                                               :value="item.value"
                                               :key="index"
                                               :checked="getCheckedValue('vehicleType[]', item.value)"
                                               @filter-update="handleCheckboxChange"
                        />
                    </LeasingSearchFilterOption>


<!--                    <LeasingSearchFilterOption-->
<!--                        :open="accordions.year.open"-->
<!--                        context="year"-->
<!--                        title="Year"-->
<!--                        @toggle-option="handleToggleOption"-->
<!--                    >-->
<!--                        <LeasingSearchFilterSelect-->
<!--                            default-value="Any"-->
<!--                            :items="-->
<!--                    filters.manufacturedYear.minManufacturedYear-->
<!--                "-->
<!--                            id="minManufacturedYear"-->
<!--                            label="From"-->
<!--                            name="minManufacturedYear"-->
<!--                            :selected-value="-->
<!--                    getSelectedValue('minManufacturedYear')-->
<!--                "-->
<!--                            @filter-update="handleFilterChange"-->
<!--                        />-->

<!--                        <LeasingSearchFilterSelect-->
<!--                            default-value="Any"-->
<!--                            :items="-->
<!--                    filters.manufacturedYear.maxManufacturedYear-->
<!--                "-->
<!--                            id="maxManufacturedYear"-->
<!--                            label="To"-->
<!--                            name="maxManufacturedYear"-->
<!--                            :selected-value="-->
<!--                    getSelectedValue('maxManufacturedYear')-->
<!--                "-->
<!--                            @filter-update="handleFilterChange"-->
<!--                        />-->
<!--                    </LeasingSearchFilterOption>-->

                    <LeasingSearchFilterOption
                        :open="accordions.bodyType.open"
                        context="bodyType"
                        title="Body type"
                        @toggle-option="handleToggleOption"
                    >
                        <LeasingSearchFilterCheckbox
                            v-for="(item, index) in filters.bodyType.bodyType"
                            :id="`bodyType-${index}`"
                            :label="item.name"
                            name="body[]"
                            :value="item.value"
                            :key="`bodyType-${index}`"
                            :checked="getCheckedValue('body[]', item.value)"
                            @filter-update="handleCheckboxChange"
                        />
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.fuelType.open"
                        context="fuelType"
                        title="Fuel type"
                        @toggle-option="handleToggleOption"
                    >
                        <LeasingSearchFilterCheckbox
                            v-for="(item, index) in filters.fuelType.fuelType"
                            :id="`fuelType-${index}`"
                            :label="item.name"
                            name="fuel[]"
                            :value="item.value"
                            :key="`fuelType-${index}`"
                            :checked="getCheckedValue('fuel[]', item.value)"
                            @filter-update="handleCheckboxChange"
                        />
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.transmission.open"
                        context="transmission"
                        title="Transmission"
                        @toggle-option="handleToggleOption"
                    >
                        <LeasingSearchFilterOptionGroup title="Gearbox">
                            <LeasingSearchFilterCheckbox
                                v-for="(item, index) in filters.transmission
                    .transmission"
                                :id="`transmission-${index}`"
                                :label="item.name"
                                name="transmission[]"
                                :value="item.value"
                                :key="`transmission-${index}`"
                                :checked="
                    getCheckedValue('transmission[]', item.value)
                "
                                @filter-update="handleCheckboxChange"
                            />
                        </LeasingSearchFilterOptionGroup>
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.price.open"
                        context="price"
                        title="Monthly Budget"
                        @toggle-option="handleToggleOption"
                    >
                        <LeasingSearchFilterSelect
                            default-value="Any"
                            :items="filters.price.minMonthlyPrice"
                            id="minMonthlyPrice"
                            label="From"
                            name="minMonthlyPrice"
                            :selected-value="
                    getSelectedValue('minMonthlyPrice')
                "
                            @filter-update="handleFilterChange"
                        />
                        <LeasingSearchFilterSelect
                            default-value="Any"
                            :items="filters.price.maxMonthlyPrice"
                            id="maxMonthlyPrice"
                            label="To"
                            name="maxMonthlyPrice"
                            :selected-value="
                    getSelectedValue('maxMonthlyPrice')
                "
                            @filter-update="handleFilterChange"
                        />
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.term.open"
                        context="term"
                        title="Term"
                        @toggle-option="handleToggleOption"
                    >
                      <LeasingSearchFilterSelect
                          default-value="Any"
                          :items="filters.term.options"
                          id="term"
                          label="Term"
                          name="term"
                          :selected-value="
                    getSelectedValue('term')
                "
                          @filter-update="handleFilterChange"
                      />
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.initialRental.open"
                        context="initialRental"
                        title="Initial rental"
                        @toggle-option="handleToggleOption"
                    >
                      <LeasingSearchFilterSelect
                          default-value="Any"
                          :items="filters.initialRental.options"
                          id="initialRental"
                          label="Initial Rental"
                          name="deposit"
                          :selected-value="
                    getSelectedValue('initialRental')
                "
                          @filter-update="handleFilterChange"
                      />
                    </LeasingSearchFilterOption>

                    <LeasingSearchFilterOption
                        :open="accordions.mileage.open"
                        context="mileage"
                        title="Mileage"
                        @toggle-option="handleToggleOption"
                    >
                      <LeasingSearchFilterSelect
                          default-value="Any"
                          :items="filters.mileage.options"
                          id="mileage"
                          label="Annual Mileage"
                          name="mileage"
                          :selected-value="
                    getSelectedValue('mileage')
                "
                          @filter-update="handleFilterChange"
                      />
                    </LeasingSearchFilterOption>

                </div>
                <div class="leasingSearchFilter__finish" v-if="windowWidth <= filterFlyoutBreakpoint">
                    <button
                        type="button"
                        class="redesignButton redesignButton--green redesignButton--full"
                        @click="toggleFilter"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div> <!-- .leasingSearchFilter -->

        <div class="leasingSearchListing__results">
            <div class="leasingSearchListing__resultsInner">

                <div class="leasingSearchListing__header" :class="{ 'leasingSearchListing__header--loading' : !loaded }">
                    <slot name="breadcrumb" />

                    <div class="leasingSearchListing__seo">
                        <slot name="seo" />

                        <div class="leasingSearchListing__count" v-if="loaded">
                            <template v-if="pagination.totalResults === 1">
                                {{ pagination.totalResults }} deal found
                            </template>

                            <template v-else>
                                {{ pagination.totalResults }} deals found
                            </template>
                        </div>

                        <div class="leasingSearchListing__count" v-else />
                    </div>

                    <div class="leasingSearchListing__topActions">
                        <div class="leasingSearchListing__sort">
                            <LeasingSearchFilterSelect :items="filters.sort.options"
                                                 id="sortBy"
                                                 :label="sortByLabel"
                                                 name="sort"
                                                 :selected-value="getSelectedValue('sort')"
                                                 @filter-update="handleFilterChange"
                            />
                        </div>

                        <button type="button"
                                class="leasingSearchListing__filterToggle"
                                @click="toggleFilter"
                                v-if="windowWidth <= filterFlyoutBreakpoint"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><path d="M496 72H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16C7.2 72 0 79.2 0 88v16c0 8.8 7.2 16 16 16h208v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h208c8.8 0 16-7.2 16-16V88c0-8.8-7.2-16-16-16zm0 320H160v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h80v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm0-160h-80v-24c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336v24c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24h80c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16z"/></svg>
                            Filter
                        </button>
                    </div>
                </div>

                <div class="leasingSearchCards" v-if="!loaded">
                    <LeasingVehicleCardLoading
                        v-for="index in loadingPlaceholders"
                        :key="index"
                    />
                </div>

                <div class="leasingSearchCards" v-else-if="results.length > 0">
                    <LeasingVehicleCard
                        v-for="result in results"
                        :id="Number(result.id)"
                        :url="`/lease-vehicle/${result.external_id}/${result.make.replace(/\s+/g, '-')}/${result.filter_model.replace(/\s+/g, '-')}.html`"
                        :image="result.default_image"
                        :title="`${result.model}`"
                        :derivative="result.derivative"
                        :price="Number(result.from_price)"
                        :highlight-text="result.highlight_text"
                        :key="result.id"
                        :cheapest-finance="result.cheapest_finance"
                        :result="result"
                    />
                </div>

                <div class="leasingSearchListing__emptyResults" v-else>
                    Sorry, no results found with those search parameters.
                </div>

               <div class="leasingSearchListing__pagination">
                    <LeasingSearchPagination
                        :page="parseInt(pagination.page)"
                        :per-page="pagination.perPage"
                        :total-pages="totalPages"
                        :total-results="pagination.totalResults"
                        @prev="decreasePagination"
                        @next="increasePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LeasingVehicleCard from './LeasingVehicleCard.vue';
import LeasingSearchFilterSelect from './LeasingSearchFilterSelect.vue';
import LeasingSearchFilterOption from './LeasingSearchFilterOption.vue';
import LeasingSearchPagination from './LeasingSearchPagination.vue';
import LeasingSearchFilterCheckbox from './LeasingSearchFilterCheckbox.vue';
import LeasingSearchFilterOptionGroup from "./LeasingSearchFilterOptionGroup.vue";
import LeasingVehicleCardLoading from "./LeasingVehicleCardLoading.vue";

export default {
    components: {
        LeasingVehicleCardLoading,
        LeasingSearchFilterOptionGroup,
        LeasingSearchFilterCheckbox,
        LeasingSearchPagination,
        LeasingSearchFilterOption,
        LeasingSearchFilterSelect,
        LeasingVehicleCard
    },
    props: {
        metaTitle: {
            type: String,
        },
        metaDescription: {
            type: String,
        },
    },
    data() {
        return {
            filters: {
                makes: {
                    options: [],
                },
                models: {
                    options: [],
                },
                manufacturedYear: {
                    minManufacturedYear: [],
                    maxManufacturedYear: [],
                },
                price: {
                    minMonthlyPrice: [], // range of 'min' monthly prices
                    maxMonthlyPrice: [], // range of 'max' monthly prices
                },
                transmission: {
                    transmission: [], // checkboxes of selectable transmissions
                },
                fuelType: {
                    fuelType: [], // checkboxes of selectable fuel types
                },
                bodyType: {
                    bodyType: [], // checkboxes of selectable body types
                },
                vehicleType: {
                    vehicleType: [], // checkboxes of selectable vehicle types
                },
                term: {
                    options: []
                },
                initialRental: {
                    options: []
                },
                mileage: {
                    options: []
                },
                sort: {
                    options: [
                        {
                            name: 'Recently added',
                            value: 'recently-added',
                        },
                        {
                            name: 'Highest price',
                            value: 'price-high',
                        },
                        {
                            name: 'Lowest price',
                            value: 'price-low',
                        },
                    ],
                },
            },
            accordions: {
                makeAndModel: {
                    open: false
                },
                type: {
                    open: false
                },
                year: {
                    open: false
                },
                bodyType: {
                    open: false
                },
                fuelType: {
                    open: false
                },
                transmission: {
                    open: false
                },
                price: {
                    open: false
                },
                term: {
                    open: false
                },
                initialRental: {
                    open: false
                },
                mileage: {
                    open: false
                },
                sort: {
                    open: false
                },
            },
            results: [],
            params: [],
            loading: false,
            loaded: false,
            pagination: {
                perPage: 24,
                page: 1,
                totalResults: null,
            },
            make: '',
            model: '',
            meta: {
                title: this.metaTitle,
                description: this.metaDescription,
            },
            windowWidth: 0, // set window width
            filterActive: false, // state for filter
            filterFlyoutBreakpoint: 960 // breakpoint for when to init flyout filter
        };
    },
    created() {
        this.setInitialFilters();
        this.getData();

        window.onpopstate = (e) => {
            this.setInitialFilters();
            this.getData();
        };

        this.windowWidth = window.innerWidth;
        window.addEventListener('resize', this.setWindowWidth);
    },
    methods: {
        setInitialFilters() {
            const url = window.location.pathname;
            const [_, __, make, model] = url.split('/');

            const params = this.getParamsToArray();

            if (make) {
                this.make = make;
            }

            if (model) {
                this.model = model;
            }

            this.params = params;

            this.pagination.page = 1;
        },
        async getData(loadMore = false) {
            const params = this.convertVueParamsToArray();

            this.loading = true;

            if (this.make !== '') {
                params.push({
                    key: 'make',
                    value: this.make,
                });
            }

            if (this.model !== '') {
                params.push({
                    key: 'model',
                    value: this.model,
                });
            }

            params.push({
                key: 'page',
                value: this.pagination.page
            });

            const url =
                params.length > 0
                    ? `/plugins/Leasing/ajax.php/?${this.convertParamsArrayToString(
                        params
                    )}`
                    : `/plugins/Leasing/ajax.php`;

            try {
                const res = await fetch(url, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                });
                const json = await res.json()

                const { filters, results, total_items, seo } =
                    json;
                const {
                    makes,
                    models,
                    manufacturedYears,
                    // minPrices,
                    // maxPrices,
                    minMonthlyPrices,
                    maxMonthlyPrices,
                    // mileages,
                    transmissions,
                    fuelTypes,
                    // seats,
                    // engineSizes,
                    // doors,
                    // colours,
                    bodyTypes,
                    // options,
                    // features,
                    vehicleTypes,
                    terms,
                    deposits,
                    mileages
                } = filters;

                if (loadMore) {
                    this.results = this.results.concat(results); // set our results
                } else {
                    this.results = results; // set our results
                }

                this.loaded = true; // finished loading
                this.loading = false; // finished loading
                this.pagination.totalResults = total_items; // set total results

                Vue.set(this.filters.makes, 'options', makes);
                Vue.set(this.filters.models, 'options', models);
                Vue.set(
                    this.filters.manufacturedYear,
                    'minManufacturedYear',
                    manufacturedYears
                );
                Vue.set(
                    this.filters.manufacturedYear,
                    'maxManufacturedYear',
                    manufacturedYears
                );
                Vue.set(
                    this.filters.price,
                    'minMonthlyPrice',
                    minMonthlyPrices
                );
                Vue.set(
                    this.filters.price,
                    'maxMonthlyPrice',
                    maxMonthlyPrices
                );
                // Vue.set(this.filters.mileage, 'minMileage', mileages);
                // Vue.set(this.filters.mileage, 'maxMileage', mileages);
                Vue.set(
                    this.filters.transmission,
                    'transmission',
                    transmissions
                );
                Vue.set(this.filters.fuelType, 'fuelType', fuelTypes);
                // Vue.set(this.filters.seats, 'seats', seats);
                // Vue.set(
                //     this.filters.engineSize,
                //     'minEngineSize',
                //     engineSizes
                // );
                // Vue.set(
                //     this.filters.engineSize,
                //     'maxEngineSize',
                //     engineSizes
                // );
                // Vue.set(this.filters.doors, 'doors', doors);
                // Vue.set(this.filters.colours, 'colours', colours);
                Vue.set(this.filters.bodyType, 'bodyType', bodyTypes);
                // Vue.set(this.filters.options, 'options', options);
                // Vue.set(this.filters.features, 'options', features);
                Vue.set(
                    this.filters.vehicleType,
                    'vehicleType',
                    vehicleTypes
                );

                Vue.set(
                    this.filters.term,
                    'options',
                    terms
                );

                Vue.set(
                    this.filters.initialRental,
                    'options',
                    deposits
                );

                Vue.set(
                    this.filters.mileage,
                    'options',
                    mileages
                );

                const { title, description } = seo;
                this.meta.title = title;
                this.meta.description = description;
            } catch (e) {
                console.error(e);
            }
        },
        handleMakeChange({ event, value }) {
            this.models = [];
            this.model = '';

            if (value.length > 0) {
                this.make = value;
            } else {
                this.make = '';
            }

            this.pagination.page = 1;
            this.params = this.convertVueParamsToArray().filter(item => item.key !== 'page');

            const baseUrl =
                this.make.length > 0
                    ? `/leasing/${this.make}/`
                    : `/leasing/`;

            const url =
                this.params.length > 0
                    ? `${baseUrl}?${this.convertParamsArrayToString(
                        this.params
                    )}`
                    : baseUrl;

            history.pushState(this.params, this.meta.title, url);

            this.scrollToElement('.leasingSearchListing');

            // refresh the data
            return this.getData();
        },
        handleModelChange({ event, value }) {
            if (value.length > 0) {
                this.model = value;
            } else {
                this.model = '';
            }

            this.pagination.page = 1;
            this.params = this.convertVueParamsToArray().filter(item => item.key !== 'page');

            const baseUrl =
                value.length > 0
                    ? `/leasing/${this.make}/${value}/`
                    : `/leasing/${this.make}/`;

            // construct url for history
            const url =
                this.params.length > 0
                    ? `${baseUrl}?${this.convertParamsArrayToString(
                        this.params
                    )}`
                    : baseUrl;

            history.pushState(this.params, this.meta.title, url);

            this.scrollToElement('.leasingSearchListing');

            return this.getData();
        },
        handleToggleOption({ open, context }) {
            for (const [key, value] of Object.entries(this.accordions)) {
                Vue.set(this.accordions[key], 'open', false);
            }

            Vue.set(this.accordions[context], 'open', !open);
        },
        handleFilterChange({ event, value, suppliedKey }) {
            let params = this.convertVueParamsToArray();
            const baseUrl = location.pathname;
            const key = typeof suppliedKey === 'string' ? suppliedKey : event.target.name;
            const found = params.find((item) => item.key === key);

            if (value) {
                if (found) {
                    found.value = value;
                } else {
                    params.push({ key, value });
                }
            } else {
                params = params.filter((item) => item.key !== key);
            }

            this.pagination.page = 1;
            this.params = params.filter(item => item.key !== 'page');

            const url =
                this.params.length > 0
                    ? `${baseUrl}?${this.convertParamsArrayToString(
                        this.params
                    )}`
                    : baseUrl;

            // update history
            history.pushState(this.params, this.meta.title, url);

            this.scrollToElement('.leasingSearchListing');

            return this.getData();
        },
        handleCheckboxChange({ enabled, event, value, suppliedKey }) {
            let params = this.convertVueParamsToArray();
            const baseUrl = location.pathname;
            const key = typeof suppliedKey === 'string' ? suppliedKey : event.target.name;
            const found = params.find(
                (item) => item.key === key && item.value === value
            );

            if (enabled) {
                if (!found) {
                    params.push({ key, value });
                }
            } else {
                if (found) {
                    params = params.filter(
                        (item) => item.key !== key || item.value !== value
                    );
                }
            }

            this.pagination.page = 1;

            this.params = params;

            const url =
                this.params.length > 0
                    ? `${baseUrl}?${this.convertParamsArrayToString(
                        this.params
                    )}`
                    : baseUrl;

            // update history
            history.pushState(this.params, this.meta.title, url);

            // scroll to top of results
            this.scrollToElement('.leasingSearchListing');

            // refresh data
            return this.getData();
        },
        getParamsToArray() {
            const searchParams = new URLSearchParams(location.search);
            const result = [];

            for (const [key, value] of searchParams.entries()) {
                result.push({ key, value });
            }

            return result;
        },
        convertVueParamsToArray() {
            return this.params.map(({ key, value }) => {
                return {
                    key,
                    value,
                };
            });
        },
        convertParamsArrayToString(params) {
            return params
                .map(
                    (item) =>
                        `${item.key}=${encodeURIComponent(item.value)}`
                )
                .join('&');
        },
        decreasePagination() {
            this.pagination.page--;
            this.scrollToElement('.leasingSearchListing');
            this.setPageParam(this.pagination.page);
            this.getData();
        },
        increasePagination() {
            this.pagination.page++;
            this.scrollToElement('.leasingSearchListing');
            this.setPageParam(this.pagination.page);
            this.getData();
        },
        setPageParam(value) {
            let params = this.convertVueParamsToArray();
            const baseUrl = location.pathname;
            const key = 'page';
            const found = params.find((item) => item.key === key);

            if (value) {
                if (found) {
                    found.value = value;
                } else {
                    params.push({ key, value });
                }
            } else {
                params = params.filter((item) => item.key !== key);
            }

            this.params = params;

            // construct url for history
            const url =
                this.params.length > 0
                    ? `${baseUrl}?${this.convertParamsArrayToString(
                        this.params
                    )}`
                    : baseUrl;

            // update history
            history.pushState(this.params, this.meta.title, url);
        },
        scrollToElement(selector) {
            const el = document.querySelector(selector);
            el.scrollIntoView({
                behavior: 'smooth',
            });
        },
        getSelectedValue(key) {
            const found = this.params.find((item) => item.key == key);

            if (!found) {
                return '';
            }

            return found.value;
        },
        getCheckedValue(key, value) {
            const found = this.params.find(
                (item) => item.key == key && item.value == value
            );

            if (!found) {
                return false;
            }

            return true;
        },
        setWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        toggleFilter() {
            this.filterActive = !this.filterActive;

            if (this.filterActive) {
                document.documentElement.classList.add('noScroll');
            } else {
                document.documentElement.classList.remove('noScroll');
            }
        },
        filterArrayForName(arr, value, prefix, isNumber = false) {
            if (isNumber) value = parseInt(value);
            let index = arr.findIndex(s => s.value === value);
            return (index > -1) ? (typeof prefix === 'string' ? prefix : '') + arr[index].name : '';
        },
        getMoreResults() {
            this.pagination.page++;
            this.getData(true);
        },
    },
    watch: {
        meta: {
            deep: true,
            handler() {
                // update meta title
                document.title = this.meta.title;
                document
                    .querySelector('meta[property="og:title"]')
                    .setAttribute('content', this.meta.title);

                // update meta description
                document
                    .querySelector('meta[name="description"]')
                    .setAttribute('content', this.meta.description);
                document
                    .querySelector('meta[property="og:description"]')
                    .setAttribute('content', this.meta.description);
            },
        },
        windowWidth(value) {
            if (value > this.filterFlyoutBreakpoint && this.filterActive) {
                this.filterActive = !this.filterActive;
                document.documentElement.classList.remove('noScroll');
            }
        },
    },
    computed: {
        loadingPlaceholders() {
            return (
                Math.min(this.pagination.perPage, this.results.length) ||
                this.pagination.perPage
            );
        },
        totalPages() {
            return Math.ceil(
                this.pagination.totalResults / this.pagination.perPage
            );
        },
        allResultsLoaded() {
            return this.results.length >= this.pagination.totalResults;
        },
        sortByLabel() {
            let baseLabel = 'Sort by'

            if (this.windowWidth > this.filterFlyoutBreakpoint) {
                return baseLabel
            }

            let svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor"><path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"/></svg>'

            return baseLabel + ' ' + svgIcon
        }
    },
    filters: {
        formatCurrency(value) {
            return new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }).format(value);
        },
        formatNumber(value) {
            return new Intl.NumberFormat().format(value);
        }
    },
};
</script>
